<script>
    import { onMount, createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();
    let statusMessage = "Loading...";

    onMount(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        console.log("Token found:", token);
        if (token) {
            localStorage.setItem('auth_token', token);
            statusMessage = "Token received and stored. Redirecting...";
            dispatch('routeChange', { page: 'profile' }); // Emitting an event
        } else {
            statusMessage = "No token found. Redirecting to home...";
            dispatch('routeChange', { page: 'home' }); // Redirect to home or login on error
        }
    });
</script>

<div>
    <p>{statusMessage}</p>
</div>